/**
 * isWebGLAvailable - cheap pre-check before mounting the three.js login
 * scene. Returns true when the browser can create a WebGL context.
 *
 * Kept dependency-free (no three.js import) so the check runs from the
 * main bundle without pulling the lazy three chunk in.
 */
export const isWebGLAvailable = () => {
  if (typeof window === "undefined" || typeof document === "undefined") {
    return false;
  }
  try {
    const canvas = document.createElement("canvas");
    const context =
      canvas.getContext("webgl2") ||
      canvas.getContext("webgl") ||
      canvas.getContext("experimental-webgl");
    return !!context;
  } catch (error) {
    return false;
  }
};
